<template>
  <v-container :fluid="$vuetify.breakpoint.mdAndDown">
    <v-row>
      <v-col cols="12">
        <h2 class="text-h4 font-weight-black">Deaths attributed to smoking</h2>
      </v-col>
      <v-col cols="12">
        <!-- <p>
          It has been well-established that smoking is a risk factor for many
          disease conditions.
        </p> -->
        <p>
          These visualisations depict the smoking attributable mortality, and
          the proportion of all deaths attributed to smoking, or the smoking
          attributable fraction (SAF), in selected high-income countries,
          stratified by sex.
        </p>
        <v-tabs v-model="selectedTab" centered>
          <v-tab key="a" href="#a"> Mortality </v-tab>
          <v-tab key="b" href="#b"> Attributable-fraction </v-tab>
          <v-tabs-slider></v-tabs-slider>
          <v-tab-item value="a">
            <v-row>
              <v-col cols="12">
                <h3 class="text-center">
                  Smoking-attributable mortality in Hong Kong and high-income
                  settings.
                </h3>
              </v-col>
              <v-col cols="12">
                <v-img :src="smoking"></v-img>
                <p class="ml-14">
                  Overall number of smoking-attributable deaths (per 100,000
                  population) in 2016
                </p>
              </v-col>
              <!-- <v-col cols="8">
                <v-img :src="smoking1"></v-img>
                <p class="ml-14">
                  † Data of year 2015 was used for Denmark<br />Data of year
                  2016 were used for other countries and jurisdictions
                </p>
                <p>
                  Note: ‘high-income countries’ represent the following 18
                  countries: Australia, Austria, Belgium, Canada, Denmark,
                  Finland, France, Germany, Italy, Japan, The Netherlands,
                  Norway, Portugal, Spain, Sweden, Switzerland, UK and USA
                </p>
              </v-col> -->
              <!-- <v-col cols="4">
                <v-img :src="smoking3"></v-img>
                <v-img :src="smoking2"></v-img>
              </v-col> -->
            </v-row>
          </v-tab-item>
          <v-tab-item value="b">
            <h3 class="text-center">
              Proportion of deaths attributed to smoking in Hong Kong and
              high-income countries.
            </h3>

            <v-img contain :src="smoking1"></v-img>
            <p>
              Note: ‘high-income countries’ represent the following 18
              countries: Australia, Austria, Belgium, Canada, Denmark, Finland,
              France, Germany, Italy, Japan, The Netherlands, Norway, Portugal,
              Spain, Sweden, Switzerland, UK and USA.
            </p>
            <p>
              Example 1: Smoking-attributable fraction has increased for women
              in HICs since 1950s, which is in contrast to the declining SAF in
              Hong Kong women since the 1980s. This has resulted in a widening
              gap in smoking-attributable mortality between HK on other HICs.
            </p>
            <p>
              Example 2: SAF Trajectories for men in Hong Kong and HICs are
              similar (1950-2017), but the proportion of deaths attributed to
              smoking in Hong Kong is substantially and consistently lower than
              that of HICs.
            </p>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import smoking from "../assets/Smoking AF including HIC (cool tone) time varying.png";
import smoking from "../assets/Smoking-attributable mortality in Hong Kong and high-income regions-added.svg";
import smoking1 from "../assets/sFigure 3.png";
// import smoking1 from "../assets/Smoking AF mx.png";
// import smoking2 from "../assets/Smoking AF.png";
// import smoking3 from "../assets/Smoking mortality.png";
export default {
  name: "Smoking",
  // data: () => ({ smoking, selectedTab: null, smoking1, smoking2, smoking3 }),
  data: () => ({ smoking, selectedTab: null, smoking1 }),
};
</script>
